module.exports = __webpack_public_path__ + "img/bmp.2384c8b8.svg";